import React, { useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import dpimg from 'assets/img/dpmain.png';
import { FaCarSide, FaCouch } from 'react-icons/fa';
import dayjs from 'dayjs';

const SharedSafariCard = ({
    safari,
    isLoggedIn,
    userProfile,
    joinSharedSafari,
    unJoinSharedSafari,
    updateSafari,
    loading,
    loadingUnJoin
}) => {
    const [imageError, setImageError] = useState(false);
    const [organizerImageError, setOrganizerImageError] = useState(false);
    const navigate = useNavigate();

    if (!safari) return null;

    const hasValidDate = safari?.start_date && safari?.month && safari?.year;
    const formattedDate = hasValidDate
        ? dayjs(`${safari.year}-${String(safari.month).padStart(2, '0')}-${String(safari.start_date).padStart(2, '0')}`).format('MMM D')
        : '';

    return (
        <div className="sharesafri_card sharesafri-card">
            {safari.types === 'Fixed Departure' && (
                <div className="fixed-depart">
                    <p>Fixed Departure</p>
                </div>
            )}

            <div className="shareimg position-relative" style={{ position: 'relative' }}>
                <Link to={`/sharedsafari/${safari?.organized_slug}/${safari?.slug}`}>
                    <img
                        src={
                            imageError || !safari?.shared_image_path
                                ? '/img/placeholder.jpg'
                                : safari.shared_image_path
                        }
                        alt="banner"
                        onError={() => setImageError(true)}
                        className="d-block w-100 h-100"
                        style={{ objectFit: 'cover', objectPosition: 'center', height: '250px' }}
                    />
                </Link>

                {/* ✅ Date Badge (Fixed) */}
                {hasValidDate && (
                    <div
                        style={{
                            position: 'absolute',
                            top: '12px',
                            right: '12px',
                            background: '#F44D1E',
                            color: '#fff',
                            padding: '6px 12px',
                            fontSize: '14px',
                            fontWeight: 'bold',
                            borderRadius: '20px',
                            zIndex: 10
                        }}
                    >
                        {formattedDate}
                    </div>
                )}

                <Row className="safari-overlay justify-content-between px-3 py-2 w-100 m-0 text-white">
                    <Col className="d-flex gap-2 align-items-center">
                        <FaCarSide size={20} className="mb-1" />
                        <p className="text_safari mb-0">SAFARI</p>
                        <p className="number-safari mb-0">{safari?.no_of_safari}</p>
                    </Col>
                    <Col className="d-flex gap-2 align-items-center justify-content-end">
                        <FaCouch size={20} className="mb-1" />
                        <p className="text_safari mb-0">SEATS</p>
                        <h6 className="number-safari mb-0">{safari?.share_seat}</h6>
                    </Col>
                </Row>
            </div>

            <div className="titleDate d-flex align-items-center gap-2 mt-2 px-2">
                <Link
                    to={
                        safari?.is_safari_operator
                            ? `/operator/${safari.organized_slug}/profile`
                            : `/profile/user/${safari.organized_slug}`
                    }
                >
                    <img
                        src={
                            organizerImageError || !safari?.organized_by_image
                                ? dpimg
                                : safari.organized_by_image
                        }
                        onError={() => setOrganizerImageError(true)}
                        alt="organizer"
                        className="rounded-circle"
                        style={{ width: 36, height: 36, objectFit: 'cover' }}
                    />
                </Link>

                <div>
                    <h6 className="mb-0" style={{ fontSize: '1rem' }}>
                        <Link to={`/park/${safari?.park_slug}`}>{safari?.park_title}</Link>
                    </h6>
                    <p>
                        Organized by:{' '}
                        <Link
                            to={
                                safari?.is_safari_operator
                                    ? `/operator/${safari.organized_slug}/profile`
                                    : `/profile/user/${safari.organized_slug}`
                            }
                            style={{ color: '#09422D' }}
                        >
                            <strong>{safari.organized_by_name}</strong>
                        </Link>
                    </p>
                </div>
            </div>

            <Row className="footer_card pb-2 px-2 align-items-center">
                <Col xs={6}>
                    <div className="users d-flex">
                        {safari?.interested_users?.slice(0, 3).map((user) => (
                            <Link
                                to={
                                    user?.is_safari_operator
                                        ? `/operator/${user.user_handle}/profile`
                                        : `/profile/user/${user.user_handle}`
                                }
                                key={user?.user_handle}
                            >
                                <img
                                    src={
                                        organizerImageError || !user.profile_display_image
                                            ? dpimg
                                            : user.profile_display_image
                                    }
                                    alt="User"
                                    className="rounded-circle bg-info"
                                    onError={() => setOrganizerImageError(true)}
                                />
                            </Link>
                        ))}
                        {Number(safari?.interseted_user_count) > 3 && (
                            <div className="roundes_countuser">
                                +{safari.interseted_user_count - 3}
                            </div>
                        )}
                    </div>
                </Col>

                <Col xs={6} className="text-end">
                    <div className="btns-safaries">
                        {isLoggedIn ? (
                            safari.organized_slug === userProfile?.user_handle ? (
                                <div className="safari text-center">
                                    <div className="joinsafari small-join-btn leavesafrai">
                                        <Link
                                            onClick={(e) => {
                                                if (loading) {
                                                    e.preventDefault();
                                                    return;
                                                }
                                                updateSafari(safari);
                                            }}
                                        >
                                            Update
                                        </Link>
                                    </div>
                                </div>
                            ) : safari.have_you_joined ? (
                                <div className="safari text-center">
                                    <div className="joinsafari small-join-btn leavesafrai">
                                        <Link
                                            onClick={(e) => {
                                                if (loadingUnJoin) {
                                                    e.preventDefault();
                                                    return;
                                                }
                                                if (safari.types === 'Fixed Departure') {
                                                    navigate(
                                                        'https://play.google.com/store/apps/details?id=com.mediarc.walkintothewild'
                                                    );
                                                } else {
                                                    unJoinSharedSafari(safari);
                                                }
                                            }}
                                        >
                                            {safari.types === 'Fixed Departure' ? (
                                                <span className="d-flex gap-2 justify-content-center">
                                                    <FontAwesomeIcon icon={faDownload} /> App
                                                </span>
                                            ) : (
                                                'Leave Safari'
                                            )}
                                        </Link>
                                    </div>
                                </div>
                            ) : (
                                <div className="safari text-center">
                                    <div className="joinsafari small-join-btn">
                                        <Link
                                            onClick={(e) => {
                                                if (loadingUnJoin) {
                                                    e.preventDefault();
                                                    return;
                                                }
                                                if (safari.types === 'Fixed Departure') {
                                                    window.location.href =
                                                        'https://play.google.com/store/apps/details?id=com.mediarc.walkintothewild';
                                                } else {
                                                    joinSharedSafari(safari);
                                                }
                                            }}
                                        >
                                            {safari.types === 'Fixed Departure' ? (
                                                <span className="d-flex gap-2 justify-content-center">
                                                    <FontAwesomeIcon icon={faDownload} /> App
                                                </span>
                                            ) : (
                                                'Join Safari'
                                            )}
                                        </Link>
                                    </div>
                                </div>
                            )
                        ) : (
                            <div className="safari text-center">
                                <div className="joinsafari small-join-btn">
                                    <Link
                                        to={`/log-in?authclient=google&referrer=${encodeURIComponent(`/sharesafari`)}`}
                                    >
                                        Join Safari
                                    </Link>
                                </div>
                            </div>
                        )}
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default SharedSafariCard;
